/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AccessExpired } from './AccessExpired';
import { AccessGranted } from './AccessGranted';
import { AccessRevoked } from './AccessRevoked';
import { CoursePermMap } from './CoursePermMap';
import { NoPaymentRequired } from './NoPaymentRequired';
import { PaymentRequired } from './PaymentRequired';
import { TransactionPending } from './TransactionPending';
const CourseAuthorizationParser = /* #__PURE__ */ parsers.object([
    [
        'paymentStatus',
        /* #__PURE__ */ parsers.lazy(() => 
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['no-payment-required', NoPaymentRequired],
            ['payment-required', PaymentRequired],
            ['transaction-pending', TransactionPending],
            ['access-granted', AccessGranted],
            ['access-expired', AccessExpired],
            ['access-revoked', AccessRevoked],
        ])),
        'payment_status',
    ],
    ['permissions', CoursePermMap],
]);
export class CourseAuthorization extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseAuthorizationParser.decode(input).map(res => new CourseAuthorization(res));
    }
    static unsafeDecode(input) {
        return CourseAuthorization.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseAuthorizationParser.encode(data);
    }
    static schema() {
        return CourseAuthorizationParser.schema();
    }
}
